@if (showDiv === 'checkout BX') {
  <div>
    @if (message) {
      <div>{{ message }}</div>
    }
    @if (extraMessage) {
      <div [innerHTML]="extraMessage"></div>
    }
  </div>
}
